import { inject } from '@angular/core';
import { Store } from '@sama/app-state';
import { AbstractUndoManager } from '../../../cross-team-shared/state/abstract-undo-manager';
import { ViewBox } from '../../../team-apis/content/view-box';
import { ViewBoxService } from '../utils/view-box.service';
import { AbstractSensorContentState2D } from './abstract-sensor-content-state-2d';

export interface UndoState2D {
  viewBox: ViewBox;
}

export abstract class AbstractContentUndoService2D<
  StateType extends AbstractSensorContentState2D,
  UndoStateType extends UndoState2D,
> extends AbstractUndoManager<StateType, UndoStateType> {
  protected viewBoxService = inject(ViewBoxService);

  constructor(rootStore: Store<StateType>) {
    super(rootStore);
  }

  protected hasTrackedChanges(
    _before: UndoStateType | undefined,
    _after: UndoStateType,
  ) {
    return false;
  }

  protected override applyUndoState(
    stateToApply: UndoStateType,
    _undoOrRedo: 'undo' | 'redo',
    _stateToOverwrite: UndoStateType,
  ) {
    this.viewBoxService.updateViewBoxAndTrack(stateToApply.viewBox);
  }
}
